import { InputAdornment, TextField } from "@mui/material";

import { PAYMENTS_MODAL_STYLES } from "../../../../payments/styles/styles";
import { getSettlementModalTextFieldSx } from "../../../style/styles";

export default function SettlementPaymentsTextField({
  fieldName,
  fieldValue,
  onChange,
  inputMode = "text",
  pattern,
  startAdornment,
  multiline = false,
}) {
  const handleChange = (event) => {
    const nextValue = event.target.value;

    if (pattern && !pattern.test(nextValue)) {
      return;
    }

    onChange(fieldName, nextValue);
  };

  return (
    <TextField
      className="w-full"
      multiline={multiline}
      minRows={multiline ? 3 : undefined}
      size="small"
      value={fieldValue}
      onChange={handleChange}
      sx={getSettlementModalTextFieldSx(PAYMENTS_MODAL_STYLES.textField)}
      inputProps={{ inputMode }}
      InputProps={{
        startAdornment: startAdornment ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : null,
      }}
    />
  );
}
